import React, { forwardRef, memo, useEffect, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CancelOrderSchema } from '../../schemas/CancelOrderSchema';
import { useForm } from 'react-hook-form';
import SelectFormField from '../SelectFormField/SelectFormField';
import FormInputRadio from "../../global/FormInputRadio/FormInputRadio";
import { CancelOrderReasonOptions } from '../../../common/constants';
import FormInputField from '../FormTextInput/FormInputField';
import { useDispatch, useSelector } from 'react-redux';
import { GetPoliciesByFileID, cancelOrderSelector, CancelOrder } from '../../../features/orders/cancelOrderSlice';
import { orderLawyerInfoSelector, setPostOrderDetailsInfo } from '../../../features/auth/orderLawyerInformationSlice';
import { authLoginSelector } from '../../../features/auth/authLoginSlice';
import { languageSelector } from "../../../features/language/languageSlice";
const CancelOrderButton = forwardRef(({
    buttonText,
    disabled,
    style = '',
    styleButton = ''
}, ref) => {
    const { t } = useTranslation();
    const lang = useSelector(languageSelector);
    const [openDialog, setOpenDialog] = useState(false);
    const [isMultiPolicy, setIsMultiPolicy] = useState(false);
    const [openDialogSuccess, setOpenDialogSuccess] = useState(false);
    const [sucessMessage, setSuccessMessage] = useState(t('CancelOrderSuccess'));
    const [policyArray, setPolicyArray] = useState([]);
    const { register, handleSubmit, reset, setFocus, setValue, getValues, trigger, control, formState: { errors }, } =
        useForm({ resolver: CancelOrderSchema(isMultiPolicy), mode: "onSubmit", defaultValues: { policies: [] } });
    const values = getValues();
    const [reasonOptions, setReasonOptions] = useState([]);
    const dispatch = useDispatch();
    const { postOrderDetailsInfo, } = useSelector(orderLawyerInfoSelector);
    const { loading, policies, fileStatus } = useSelector(cancelOrderSelector);
    const { userLogin } = useSelector(authLoginSelector);
    const [oneOpenDialog, setOneOpenDialog] = useState(false);
    const [prevFileStatus, setPrevFileStatus] = useState('');

    useImperativeHandle(ref, () => ({
        handlesubmitform(val) {
            handleSubmit(submitform)(val);
        },
    }));

    useEffect(() => {
        policies?.length > 1 && setIsMultiPolicy(true);
        setPolicyArray(policies);
    }, [policies])

    const onExit = () => {
        reset();
        setOpenDialog(false);
    }

    const onCancelClick = () => {
        setReasonOptions(CancelOrderReasonOptions?.CancelReason?.map(
            (item, i) => {
                return { label: t(item.label), value: item.value };
            }
        ));
        dispatch(GetPoliciesByFileID(postOrderDetailsInfo?.fileID));
        setOpenDialog(true)
    }

    const dropdownChange = (e, name) => {
        setValue(name, e);
        trigger(name);
    }
    const handleChange = (e) => {
        e.persist();
        setValue(e?.target?.name, e?.target?.value);
        trigger(e?.target?.name);
    }


    const submitform = async (data) => {
        reset();
        setOpenDialog(false);
        setOneOpenDialog(true);
        let policyArry = [];
        if (isMultiPolicy && data?.cancelWholeOrder === 'Yes') {
            policyArray.forEach((Element, index) => {
                policyArry.push(Element?.id + '_' + (Element?.isOwner ? 1 : 0))
            })
        }
        else {
            policyArry = data?.policies;
        }

        let req = {
            FileID: postOrderDetailsInfo?.fileID,
            IsCancelAll: !isMultiPolicy ? true : data?.cancelWholeOrder === 'Yes' ? true : false,
            IsMultiPolicy: isMultiPolicy,
            Policies: policyArry?.join('|'),
            Reason: data?.reason,
            ReasonOther: data?.reasonOther,
        }
        setPrevFileStatus(postOrderDetailsInfo?.fileStatus);
        dispatch(CancelOrder(req, userLogin?.userId));
    };

    const onOK = () => {
        setOpenDialogSuccess(false);
        let request = {
            fileID: postOrderDetailsInfo?.fileID,
            fileNumber: postOrderDetailsInfo?.fileNumber,
            dealType: postOrderDetailsInfo?.dealType,
            fileStatus: fileStatus,
        };
        dispatch(setPostOrderDetailsInfo(request));
    }

    useEffect(() => {
        if (fileStatus && fileStatus !== null && fileStatus !== '' && oneOpenDialog && !loading) {
            setOneOpenDialog(false);

            !isMultiPolicy && prevFileStatus === 'Not Yet Submitted' ? setSuccessMessage(t('OrderCancelled')) :
                fileStatus === 'Cancelled' ? setSuccessMessage(t('CancelOrderSuccess')) :
                    isMultiPolicy ? setSuccessMessage(t('CancelOrderSuccessPendingMultiPloicy')) : setSuccessMessage(t('CancelOrderSuccessPending'));

            if (userLogin?.internalUser && fileStatus === 'Cancelled') {//need to check what msg sould show when internal user cancel the order
                setSuccessMessage(t('OrderCancelled'));
            }
            setOpenDialogSuccess(true);
        }

    }, [fileStatus, oneOpenDialog, loading])

    console.log(errors);

    return (
        <>
            <div className={`flex justify-end ${style} mt-2`}>
                <button
                    className={`btn__primary flex py-[10px] justify-center px-2 ${styleButton}`}
                    type="button"
                    id="submit"
                    disabled={disabled}
                    data-cy="cancelOrder"
                    onClick={onCancelClick}
                >
                    {buttonText}
                </button>
            </div>

            {openDialog && (
                <dialog
                    id='delete_dialog2'
                    className='bottom-0 fixed flex h-full inset-x-0 px-4 sm:inset-0 sm:items-center sm:justify-center w-full z-40'
                    open
                >
                    <span
                        className='w-[483px] bg-white overflow-hidden pl-[50px] pr-[25px] pt-[52px] py-[48px] relative rounded'
                        style={{ boxShadow: '0 4px 14px #0003' }}
                    >
                        <img
                            src='/images/exit.ca93bf87.svg'
                            alt='Exit Logo'
                            onClick={onExit}
                            className='!cursor-pointer absolute h-[14px] right-[25px] top-[25px] w-[14px]'
                        />
                        <span className='flex gap-[10px] items-center mb-[16px]'>
                            <h1 className='font-[700] font-montserrat text-left text-xl'>
                                {t('CancelOrder')}
                            </h1>
                        </span>
                        <span className='!font-[400] font-open-sans text-base text-gray-800 text-left'>
                            <div className='flex flex-col'>
                                {isMultiPolicy && (
                                    <>
                                        <div className='flex flex-row mb-2'>
                                            <div className='inline-flex space-x-1'>
                                                <FormInputRadio
                                                    fieldName={`cancelWholeOrder`}
                                                    testId={`cancelWholeOrder`}
                                                    id={`cancelWholeOrder`}
                                                    register={register}
                                                    handleChange={handleChange}
                                                    errorMessage={t(
                                                        errors?.cancelWholeOrder?.message
                                                    )}
                                                    label={t('CancelWholeOrder')}
                                                    labelClasses='font-semibold  mr-2'
                                                    answerOption={[
                                                        {
                                                            id: `cancelWholeOrder`,
                                                            value: 'Yes',
                                                            label: t('yes'),
                                                            name: `cancelWholeOrder`,
                                                        },
                                                        {
                                                            id: `cancelWholeOrder`,
                                                            value: 'No',
                                                            label: t('no'),
                                                            name: `cancelWholeOrder`,
                                                        },
                                                    ]}
                                                    isChild={false}
                                                    loading={false}
                                                />
                                            </div>
                                        </div>
                                        {values?.cancelWholeOrder === 'No' && (
                                            <div className='flex flex-row mt-4'>
                                                <label htmlFor='ab-checkbox' className='mr-4'>
                                                    {t('SelectPolicyToCancel')}
                                                </label>
                                                <div className='flex flex-col'>
                                                    {policyArray?.map((item, index) =>
                                                        <div className='flex flex-row mt-1'>
                                                            <input
                                                                id='policies-checkbox'
                                                                {...register('policies')}
                                                                name='policies'
                                                                type='checkbox'
                                                                value={item?.id + '_' + (item?.isOwner ? 1 : 0)}
                                                                className='w-4 h-4 custom__checkbox custom__checkbox-multiple'
                                                            />
                                                            <label htmlFor='ab-checkbox' className='ml-2 mt_-1'>
                                                                {item?.policyName}
                                                            </label>
                                                        </div>
                                                    )}
                                                    <div className='flex flex-row pt-2'>
                                                        <span className='font-semibold text-secondary-red'>
                                                            {errors.policies &&
                                                                t('RequiredFieldErrMsg')}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}

                                <div className='flex flex-row'>
                                    <SelectFormField
                                        testId="cancel_reason"
                                        label={t("CancelReason")}
                                        options={reasonOptions || []}
                                        dropdownChange={dropdownChange}
                                        control={control}
                                        loading={false}
                                        fieldName="reason"
                                        errorMessage={errors.reason && t("RequiredFieldErrMsg")}
                                        ariaLabel="reason"
                                        labelClassNames="questionnaire font-semibold w-[auto] pt-2"
                                        selectClassNames="custom__dropdown-wrapper size__md"
                                        currentValue={
                                            values && values["reason"]
                                                ? values["reason"]
                                                : null
                                        }
                                    />
                                    <hr />
                                </div>
                                {values?.reason === 'Other' && (
                                    <div className='flex flex-col'>
                                        <div className='flex flex-row'>
                                            <FormInputField
                                                fieldName='reasonOther'
                                                type='text'
                                                id='reasonOther'
                                                errorMessage={errors.reasonOther && t('RequiredFieldErrMsg')}
                                                register={register}
                                                handleChange={handleChange}
                                                label={t('ProvideDetails')}
                                                placeholder={
                                                    errors.reasonOther
                                                        ? t(errors?.reasonOther?.message)
                                                        : t('ProvideReason')
                                                }
                                                inputClassnames='w-[420px] mr-4 text-neutrals-black pl-8'
                                                labelClasses={`questionnaire font-semibold w-[auto] pt-2 ${lang?.value === "fr" ? 'pr-125' : ''}`}
                                                mainClassnames='border-box-stroke text-gray-900 text-sm rounded-sm block w-full p-2.5 hover:border-placeholder hover:background-[#FAFAFA] 
                                            focus:border-placeholder focus:bg-neutral-50 focus:ring-transparent'
                                                disabled={false}
                                                error={errors.reasonOther}
                                                isMultiLineText={true}
                                            />
                                        </div>
                                        <div className='flex flex-row pt-2 mleft-34'>
                                            <span className='font-semibold text-secondary-red'>
                                                {errors.reasonOther &&
                                                    getValues('reasonOther').length > 0 &&
                                                    t('ProvideReasonOtherError')}
                                            </span>
                                        </div>
                                    </div>
                                )}

                            </div>
                            <span className='flex gap-[28px] items-end justify-end mt-20'>
                                <button
                                    id='close-button'
                                    tabIndex='0'
                                    className='!btn__tertiary !flex !items-center !justify-center !py-[9px] !text-secondary-red !w-[83px]'
                                    aria-label='Close'
                                    type='button'
                                    onClick={onExit}
                                >
                                    {t('Exit')}
                                </button>
                                <button
                                    id='delete-button'
                                    tabIndex='0'
                                    className='!bg-primary-yellow !btn__primary !flex !h-[40px] !hover:bg-primary-yellow-100 !items-center !justify-center !px-[16px] !text-black !w-fit'
                                    aria-label='Close'
                                    type='button'
                                    onClick={() => handleSubmit(submitform)()}
                                >
                                    {t('confirmCancel')}
                                </button>
                            </span>
                        </span>
                    </span>
                </dialog>
            )}

            {openDialogSuccess && (
                <dialog
                    id='delete_dialog2'
                    className='bottom-0 fixed flex h-full inset-x-0 px-4 sm:inset-0 sm:items-center sm:justify-center w-full z-40'
                    open
                >
                    <span
                        className='w-[420px] bg-white overflow-hidden pl-[50px] pr-[25px] pt-[52px] py-[48px] relative rounded-2'
                        style={{ boxShadow: '0 4px 14px #0003' }}
                    >
                        <img
                            src='/images/exit.ca93bf87.svg'
                            alt='Exit Logo'
                            onClick={onOK}
                            className='!cursor-pointer absolute h-[14px] right-[25px] top-[25px] w-[14px]'
                        />
                        <span className='font-bold text-secondary-red'>{sucessMessage}</span>
                        <span className='flex gap-[28px] items-end justify-center mt-6'>
                            <button
                                id='close-button'
                                tabIndex='0'
                                className='!bg-primary-yellow !btn__primary !flex !h-[40px] !hover:bg-primary-yellow-100 !items-center !justify-center !px-[16px] !text-black !w-[90px]'
                                aria-label='Close'
                                type='button'
                                onClick={onOK}
                            >
                                {t('OK')}
                            </button>

                        </span>
                    </span>
                </dialog>
            )}
        </>
    );
}
);

export default memo(CancelOrderButton);